import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useProductLineItem} from '../hooks/useProductLineItem.ts';

import {useEditPageTools} from '../hooks/useEditPageTools';

import {useProductLineItems} from "../hooks/useProductLineItems.ts";


export const EditPage = () => {

    const {
        id: productId,
        productLineItemId
    } = useParams();

    if (typeof productId === 'undefined') {
        throw new Error('productId is required parameter');
    }

    const {fetchRecords} = useProductLineItems(productId || '');

    const {
        record: product,
        fetchRecord,
        updateRecord,
    } = useProductLineItem(productId, productLineItemId);

    const {
        mode,
        tools,
    } = useEditPageTools();

    useEffect(() => {
        fetchRecords();
    }, []);

    useEffect(() => {
        fetchRecord();
    }, [productId]);

    if (!product) {
        return <PlatformLoader message='Loading product...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={product.id}
            pageNavigation={<EditPageNavigation component={product}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={product}
                    />

                    {/*
                    <AccountsPage/>
*/}

                </Stack>
                :
                <RecordForm
                    record={{...product, name: product.id, status: 'Active'} as any}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};
